import React from "react";
import isEmpty from "lodash/isEmpty";
import { Controller } from "react-hook-form";
import { EuiFormRow, EuiSelect, EuiSelectOption } from "@elastic/eui";

export interface Option {
  value: string | number | boolean;
  text: string;
}

export interface ISelectForm {
  control: any;
  name: string;
  require?: boolean | false;
  label: string;
  errors: any;
  isDisable?: boolean | false;
  options: EuiSelectOption[];
}

export function SelectForm(props: ISelectForm) {
  return (
    <Controller
      name={props.name}
      control={props.control}
      rules={{ required: props.require }}
      render={({ field }) => {
        const { ref, ...otherProps } = field;
        return (
          <EuiFormRow
            fullWidth
            isDisabled={props.isDisable}
            label={props.label}
            isInvalid={!isEmpty(props.errors[props.name])}
            error={props?.errors[props.name]?.message}
          >
            <EuiSelect fullWidth options={props.options} {...otherProps} />
          </EuiFormRow>
        );
      }}
    />
  );
}
